import React from "react"

import { Control } from "react-hook-form"

import RatingSelect from "./RatingSelect"
import SectionHeader from "./SectionHeader"

interface DeliveryProtocolSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  calculateResult: () => void
}

const deliveryProtocolOptions = [
  { value: "Up to Standard", label: "Up to Standard" },
  { value: "Satisfactory", label: "Satisfactory" },
  { value: "Needs Improvement", label: "Needs Improvement" },
  { value: "Failed Protocol", label: "Failed Protocol" },
]

const DeliveryProtocolSection: React.FC<DeliveryProtocolSectionProps> = ({
  control,
  calculateResult,
}) => {
  return (
    <div className="space-y-4">
      <SectionHeader title="Delivery Protocol Adherence" />

      <div className="grid grid-cols-1 gap-4">
        <RatingSelect
          control={control}
          name="deliveryProtocolScores.deliveryPictures"
          label="Delivery Pictures"
          options={deliveryProtocolOptions}
          calculateResult={calculateResult}
        />
        <RatingSelect
          control={control}
          name="deliveryProtocolScores.deliveryNotes"
          label="Delivery Notes"
          options={deliveryProtocolOptions}
          calculateResult={calculateResult}
        />
        <RatingSelect
          control={control}
          name="deliveryProtocolScores.instructionCompliance"
          label="Instruction Compliance"
          options={deliveryProtocolOptions}
          calculateResult={calculateResult}
        />
      </div>
    </div>
  )
}

export default DeliveryProtocolSection
